module.exports = __webpack_public_path__ + "static/media/bg.02feea0a.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.webm
// module id = 161
// module chunks = 0